module.exports = __webpack_public_path__ + "static/media/parent-dashboard-welcome.c93c5bc8.svg";